module.exports = __webpack_public_path__ + "img/karyatama-logo.07cbc14d.png";